import type { CustomDashboardsQueryResponse } from '@cast/types';

export const MOCK_CUSTOM_DASHBOARDS_QUERY_RESPONSE: CustomDashboardsQueryResponse =
  {
    data: {
      query: {
        measures: ['workloads.total_cost'],
        timeDimensions: [
          {
            dimension: 'workloads.Time',
            granularity: 'day',
            dateRange: ['2026-10-10', '2026-10-17'],
          },
        ],
      },
      data: [
        { 'workloads.total_cost': 128.4 },
        { 'workloads.total_cost': 132.9 },
        { 'workloads.total_cost': 141.2 },
        { 'workloads.total_cost': 127.5 },
        { 'workloads.total_cost': 119.8 },
        { 'workloads.total_cost': 98.3 },
        { 'workloads.total_cost': 96.1 },
      ],
      annotation: {
        measures: {
          'workloads.total_cost': {
            title: 'Total cost',
            shortTitle: 'Cost',
            type: 'number',
          },
        },
        dimensions: {},
        timeDimensions: {
          'workloads.Time': {
            title: 'Time',
            shortTitle: 'Time',
            type: 'time',
          },
        },
        segments: {},
      },
      lastRefreshTime: '2026-10-17T00:00:00.000Z',
      external: false,
      dbType: 'ClickHouse',
      extDbType: 'ClickHouse',
    },
  };

export const MOCK_CUSTOM_DASHBOARDS_CONTINUE_WAIT_RESPONSE: CustomDashboardsQueryResponse =
  { data: { error: 'Continue wait' } };
